import React from 'react';
import BasePage from './BasePage';
import { connect } from 'react-redux';
import configData from "../config.json";
import { setModalContent, setFiltersContent, setSelectedFilters, setBillsPagination } from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Filters from '../components/Filters';
import Table from '../components/Table';
import $ from 'jquery';

class Bills extends BasePage {

	/*
	TODO: Agregar checkbox a cada factura para poderlas exportar/imprimir segun la seleccion.
	Para solucionar el problema de imprimirlas todas y se junten en la misma pagina, agregar esto al comienzo de cada
	elemento html donde comienza la factura. Es un salto de linea en css: style={{pageBreakBefore: 'always'}}
	*/

	loadOnConstructor() {
		this.getBills = this.getBills.bind(this);
		this.newBill = this.newBill.bind(this);
		this.deleteClick = this.deleteClick.bind(this);
		this.deleteBill = this.deleteBill.bind(this);
		this.deleteBillCallback = this.deleteBillCallback.bind(this);
		this.duplicateClick = this.duplicateClick.bind(this);
		this.duplicateBill = this.duplicateBill.bind(this);
		this.clickPaginationCallback = this.clickPaginationCallback.bind(this);
		this.parseBillResponse = this.parseBillResponse.bind(this);
		this.showFilters = this.showFilters.bind(this);
		this.filterResults = this.filterResults.bind(this);
		this.searchCallback = this.searchCallback.bind(this);
		this.excelExport = this.excelExport.bind(this);
		this.generateReturnPayBillClick = this.generateReturnPayBillClick.bind(this);
		this.generateReturnPayBill = this.generateReturnPayBill.bind(this);

		let initialStartExpirationDate = new Date();
		let initialEndExpirationDate = new Date();
		initialStartExpirationDate.setDate(1);
		initialStartExpirationDate.setHours(0);
		initialStartExpirationDate.setMinutes(0);
		initialStartExpirationDate.setSeconds(0);

		initialEndExpirationDate.setMonth(initialEndExpirationDate.getMonth() + 1);
		initialEndExpirationDate.setDate(0);
		initialEndExpirationDate.setHours(23);
		initialEndExpirationDate.setMinutes(59);
		initialEndExpirationDate.setSeconds(59);

		const initialStartCreatedDate = new Date(initialStartExpirationDate.getTime());
		const initialEndCreatedDate = new Date(initialEndExpirationDate.getTime());

		let filters = []

		if(this.props.selectedFilters.creation_date){
			if(this.props.selectedFilters.creation_date.active){
				filters.push({ name: "creation_date_start", value: this.parseDateToString(this.props.selectedFilters.creation_date.start) });
				filters.push({ name: "creation_date_end", value: this.parseDateToString(this.props.selectedFilters.creation_date.end) });
			}
		}else{
			filters.push({ name: "creation_date_start", value: this.parseDateToString(initialStartCreatedDate) });
			filters.push({ name: "creation_date_end", value: this.parseDateToString(initialEndCreatedDate) });
		}

		/*
		if(this.props.selectedFilters.billCode?.active){
			filters.push({ name: "billCode", value: this.props.selectedFilters.billCode.value });
		}
		*/

		if(this.props.selectedFilters.expiration_date?.active){
			filters.push({ name: "expiration_date_start", value: this.parseDateToString(this.props.selectedFilters.expiration_date.start) });
			filters.push({ name: "expiration_date_end", value: this.parseDateToString(this.props.selectedFilters.expiration_date.end) });
		}

		this.state = {
			searchParams: filters,
			initialStartCreatedDate,
			initialEndCreatedDate,
			initialStartExpirationDate,
			initialEndExpirationDate,
			initialActiveCreatedDate: true,
			
			initialActiveExpirationDate: false
		};

		this.getBills('interface');
	}

	getBills(type) {

		const api = this.getApi();

		//if(typeof this.state.startCreatedDate === 'string') startCreatedDate = new Date(startCreatedDate)
		//if(typeof this.state.endCreatedDate === 'string') endCreatedDate = new Date(endCreatedDate)

	 	let apiParams = [
			{ name: 'page', value: this.props.billsPagination?.currentPage ? this.props.billsPagination.currentPage : 1 },
			{ name: 'limit', value: configData.rowsPerPage }
		];

		if (this.state.searchParams) {
			for(const param of this.state.searchParams){
				if(param.name === 'billCode'){
					apiParams = apiParams.filter(param => param.name!=='page')
					apiParams.push({ name: 'page', value:1})
				}
			}
			
			apiParams = apiParams.concat(this.state.searchParams);
		}

		if (type === 'interface') {
			api.getBillsInterface(apiParams, this.parseBillResponse);
		} else if (type === 'download') {
			apiParams.push({ name: 'export_to_file', value: 1 });
			api.downloadBills(apiParams, this.parseBillResponse);
		} else {
			api.getBills(apiParams, this.parseBillResponse);
		}
	}

	parseBillResponse(response) {
		if (response.status === 'OK') {

			const extraData = response.extra_data.map(ed => {
				ed.total_price = Math.round(parseFloat(ed.total_price.replace(/€/,'')) * 100) / 100
				ed.total_price = ed.total_price+'€'
				return ed
			})

			this.props.setBillsPagination({
				totalItems: response.totalItems,
				totalPages: response.totalPages,
				currentPage: response.currentPage
			})

			this.setState(prevState => {
				return {
					...prevState,
					totalItems: response.totalItems,
					totalPages: response.totalPages,
					currentPage: response.currentPage,
					bills: response.bills,
					extra_data: extraData,
					canCreateBill: this.state.canCreateBill !== undefined?this.state.canCreateBill:response.canCreateBill,
					canOpenFilters: this.state.canOpenFilters !== undefined?this.state.canOpenFilters:response.canOpenFilters,
					i18n: this.state.i18n !== undefined?this.state.i18n:response.i18n
				}
			});

		} else if (this.state.download) {//Es download
			this.setState(prevState => {
				return {
					...prevState,
					download: 0
				}
			});

			const newBlob = new Blob([response], { type: 'application/octet-stream' });

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
			} else {
				// For other browsers: create a link pointing to the ObjectURL containing the blob.
				const objUrl = window.URL.createObjectURL(newBlob);

				let link = document.createElement('a');
				link.href = objUrl;
				link.download = "Facturas.xlsx";
				link.click();

				// For Firefox it is necessary to delay revoking the ObjectURL.
				setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 1000);
			}
		} else if (response.auth === false) {
			this.navigateTo('/login');
		}
	}

	newBill() {
		this.navigateTo('/edit_bill');
	}

	clickPaginationCallback(pageNumber) {

		this.props.setBillsPagination({
			totalItems: this.props.billsPagination.totalItems,
			totalPages: this.props.billsPagination.totalPages,
			currentPage: pageNumber
		})
		
		this.setState(prevState => {
			return {
				...prevState,
				page: pageNumber
			}
		}, this.getBills);
	}

	deleteClick(event) {

		this.props.setModalContent({
			title: this.getTrad('confirmAction'),
			body: [this.getTrad('doYouWantToDeleteBill')],
			buttons: [
				{ shown: 'Aceptar', close: true, behaviour: 'main', callback: this.deleteBill.bind(this, event.target.id) },
				{ shown: 'Cancelar', behaviour: 'secondary', close: true }
			]
		});

		$("#exampleModal").modal('toggle');
	}

	deleteBill(buttonName) {
		const parts = buttonName.split('_');

		this.setState(prevState => {
			return {
				...prevState,
				deletedBill: parts[1]
			}
		});
		const api = this.getApi();
		api.deleteBill(parts[1], this.deleteBillCallback);
	}

	deleteBillCallback(response) {

		if (response && response.status === 'OK') {

			const bills = this.state.bills.filter(bill => { return bill._id !== this.state.deletedBill });
			const extra_data = this.state.extra_data.filter(ed => { return ed._id !== this.state.deletedBill });

			this.setState(prevState => {
				return {
					...prevState,
					extra_data,
					bills
				}
			});
			setTimeout(() => {
				this.props.setModalContent({
					title: this.getTrad('messageFromServer'),
					body: [this.getTrad('billDeletedSuccessfully')],
					buttons: [
						{ shown: 'Cerrar', close: true, behaviour: 'main' }
					]
				});

				$("#exampleModal").modal('toggle');
			}, 500);
		} else {
			setTimeout(() => {
				this.props.setModalContent({
					title: this.getTrad('messageFromServer'),
					body: [this.getTrad(response.message)],
					buttons: [
						{ shown: 'Cerrar', close: true, behaviour: 'main' }
					]
				});

				$("#exampleModal").modal('toggle');
			}, 500);
		}
	}

	duplicateClick(event) {

		this.props.setModalContent({
			title: this.getTrad('confirmAction'),
			body: [this.getTrad('doYouWantToDuplicateBill')],
			buttons: [
				{ shown: 'Aceptar', close: true, behaviour: 'main', callback: this.duplicateBill.bind(this, event.target.id) },
				{ shown: 'Cancelar', behaviour: 'secondary', close: true }
			]
		});

		$("#exampleModal").modal('toggle');
	}

	duplicateBill(buttonName) {
		const parts = buttonName.split('_');
		this.navigateTo('/edit_bill?duplicate_id='+parts[1])	
	}

	generateReturnPayBillClick(event){

		this.props.setModalContent({
			title: this.getTrad('confirmAction'),
			body: [this.getTrad('doYouWantToGenerateReturnPayBill')],
			buttons: [
				{ shown: 'Aceptar', close: false, behaviour: 'main', callback: this.generateReturnPayBill.bind(this, event.target.id) },
				{ shown: 'Cancelar', behaviour: 'secondary', close: true }
			]
		});

		$("#exampleModal").modal('toggle');
	}

	generateReturnPayBill(billId){
		const parts = billId.split('_');

		const api = this.getApi()
		api.generateReturnPayBill(parts[1], (response) => { 
			let title = this.getTrad('messageFromServer')
			let body = [this.getTrad('returnPayBillWasGeneratedSuccessfully')]
			
			if(response.status !== 'OK'){
				body= [this.getTrad(response.message)]	
			}
			setTimeout( () => {
				this.props.setModalContent({
					title,
					body,
					buttons: [
						{ shown: 'Cerrar', close: true, behaviour: 'main'}
					]
				});
				
			}, 1000)

		})
	}

	showFilters() {
		//if (!this.state.canOpenFilters) return false;
		let selectedFilters = {
			billCode: {
				value: this.props.selectedFilters.billCode?.value !== undefined?
					this.props.selectedFilters.billCode.value:'',
				active: this.props.selectedFilters.billCode?.active !== undefined?
					this.props.selectedFilters.billCode.active:false
			},
			expiration_date: { 
				start: this.props.selectedFilters.expiration_date !== undefined?
					this.props.selectedFilters.expiration_date.start: this.state.initialStartCreatedDate, 
				end: this.props.selectedFilters.expiration_date !== undefined?
					this.props.selectedFilters.expiration_date.end:this.state.initialEndCreatedDate,
				active: this.props.selectedFilters.expiration_date!== undefined?
					this.props.selectedFilters.expiration_date.active:this.state.initialActiveExpirationDate
			 },
			creation_date: { 
				start: this.props.selectedFilters.creation_date?this.props.selectedFilters.creation_date.start:
					this.state.initialStartCreatedDate, 
				end: this.props.selectedFilters.creation_date?this.props.selectedFilters.creation_date.end:
				this.state.initialEndCreatedDate, 
				active: this.props.selectedFilters.creation_date?this.props.selectedFilters.creation_date.active:
					this.state.initialActiveCreatedDate
			}
		}

		this.props.setSelectedFilters(selectedFilters);
		this.props.setFiltersContent({
			title: 'Edite sus filtros',
			users: this.state.users,
			billCode: {
				value: this.props.selectedFilters.billCode?.value !== undefined?
					this.props.selectedFilters.billCode.value:'',
				active: this.props.selectedFilters.billCode?.active !== undefined?
					this.props.selectedFilters.billCode.active:false
			},
			expiration_date: { 
				start: this.props.selectedFilters.expiration_date !== undefined?
					this.props.selectedFilters.expiration_date.start: this.state.initialStartCreatedDate, 
				end: this.props.selectedFilters.expiration_date !== undefined?
					this.props.selectedFilters.expiration_date.end:this.state.initialEndCreatedDate,
				active: this.props.selectedFilters.expiration_date!== undefined?
					this.props.selectedFilters.expiration_date.active:this.state.initialActiveExpirationDate
			 },
			creation_date: { 
				start: this.props.selectedFilters.creation_date?this.props.selectedFilters.creation_date.start:
					this.state.initialStartCreatedDate, 
				end: this.props.selectedFilters.creation_date?this.props.selectedFilters.creation_date.end:
				this.state.initialEndCreatedDate, 
				active: this.props.selectedFilters.creation_date?this.props.selectedFilters.creation_date.active:
					this.state.initialActiveCreatedDate
			},
			buttons: [
				{ shown: 'Aplicar', close: true, callback: this.filterResults, behaviour: 'main' },
				{ shown: 'Cerrar', close: true }
			]
		});

		$("#filters-component").modal('toggle');
	}

	filterResults() {
		let filters = [];

		let creationDateModified = false

		for (let prop in this.props.selectedFilters) {
			if(prop === 'billCode'){
				if(this.props.selectedFilters[prop].active){
					filters.push({ name: "billCode", value: this.props.selectedFilters[prop].value })
				}
			}
			if (prop === 'users') {
				filters.push({ name: "user_in", value: this.props.selectedFilters[prop].join() })
			}
			if (prop === 'expiration_date') {
				if(this.props.selectedFilters[prop].active){
					filters.push({ name: "expiration_date_start", value: this.parseDateToString(this.props.selectedFilters[prop].start) });
					filters.push({ name: "expiration_date_end", value: this.parseDateToString(this.props.selectedFilters[prop].end) });
				}
			}
			if (prop === 'creation_date') {
				if(this.props.selectedFilters[prop].active){
					creationDateModified = {
						start: this.parseDateToString(this.props.selectedFilters[prop].start),
						end: this.parseDateToString(this.props.selectedFilters[prop].end)
					}

					filters.push({ name: "creation_date_start", value: this.parseDateToString(this.props.selectedFilters[prop].start) });
					filters.push({ name: "creation_date_end", value: this.parseDateToString(this.props.selectedFilters[prop].end) });
				}
			}
		}

		if(creationDateModified){
			this.setState(prevState => {
				return {
					...prevState,
					page: 1,
					searchParams: filters,
					startCreatedDate: creationDateModified.start,
					endCreatedDate: creationDateModified.end,
				}
			}, this.getBills);
		}else{
			this.setState(prevState => {
				return {
					...prevState,
					page: 1,
					searchParams: filters
				}
			}, this.getBills);
		}
	}

	parseDateToString(date) {
		if(typeof date !== 'object') return date

		const hoursFromTimezoneOffset = (date.getTimezoneOffset() * -1) / 60;
		let dateToString = new Date(date.getTime());
		dateToString.setHours(date.getHours() + hoursFromTimezoneOffset);

		return dateToString.getUTCFullYear() + "-" +
			("0" + (dateToString.getUTCMonth() + 1)).slice(-2) + "-" +
			("0" + dateToString.getUTCDate()).slice(-2) + " " +
			("0" + dateToString.getUTCHours()).slice(-2) + ":" +
			("0" + dateToString.getUTCMinutes()).slice(-2) + ":" +
			("0" + dateToString.getUTCSeconds()).slice(-2);
	}

	searchCallback(response) {

		this.props.setBillsPagination({
			totalItems: response.totalItems,
			totalPages: response.totalPages,
			currentPage: response.currentPage
		})
		//this.props.setUsers(response.users);
		this.setState(prevState => {
			return {
				...prevState,
				bills: response.bills,
				totalItems: response.totalItems,
				totalPages: response.totalPages,
				currentPage: response.currentPage
			}
		});

	}

	excelExport(){
		this.setState(prevState => {
		return {
			...prevState,
			download: true
		}
		},this.getBills.bind(this,'download'));
	}

	render() {
		return (
			<div className="container">
				<Menu />
				<h3>{this.getTrad('BillsAdmin')}</h3>
				<div className="row mb-2 mt-4">
					<div className="col-4">
						{this.state.canCreateBill ? <button type="button" className="btn btn-primary" onClick={this.newBill}>
							{this.getTrad('NewBill')}
						</button> : ''}
					</div>
					<div className="col-4 text-center">
						<button className="btn btn-secondary" onClick={this.showFilters}>Mostrar filtros</button>
						{/*<button className="btn btn-secondary" onClick={this.verState}>Ver STATE</button>*/}
                    </div>
					<div className="col-4 text-right">
						<button className="btn btn-secondary" onClick={this.excelExport}>Exportar a excel</button>

					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<Table
							config={{
								items: this.state.bills,
								extra_data: this.state.extra_data,
								i18n: this.state.i18n !== undefined ? this.state.i18n : [],
								mapping: [
									{
										original: 'code', shown: this.getTrad('code'), visible: true, click: {
											url: '/edit_bill', params: [{ name: 'bill_id', field: '_id' }]
										}
									},
									{
										original: 'creation_date', shown: 'Fecha emisión', visible: true, display: 'extra_data', 
										extra_data: {match: '_id', value: 'creation_date'},  textCenter: 1,
										click: {
											url: '/edit_bill', params: [{ name: 'bill_id', field: '_id' }]
										}
									},
									{
										original: 'type', shown: 'Tipo', visible: true, display: 'extra_data', 
										extra_data: {match: '_id', value: 'type'},
										click: {
											url: '/edit_bill', params: [{ name: 'bill_id', field: '_id' }]
										}
									},
									{
										original: 'client', shown: 'Cliente', visible: true, display: 'extra_data', 
										extra_data: {match: '_id', value: 'client'},
										click: {
											url: '/edit_bill', params: [{ name: 'bill_id', field: '_id' }]
										}
									},
									{
										original: 'status', shown: 'Estado', visible: true, display: 'extra_data', 
										extra_data: {match: '_id', value: 'status'},
										click: {
											url: '/edit_bill', params: [{ name: 'bill_id', field: '_id' }]
										}
									},
									{
										original: 'total_price', shown: 'Importe', visible: true, display: 'extra_data', 
										extra_data: {match: '_id', value: 'total_price'}, textRight: 1,
										click: {
											url: '/edit_bill', params: [{ name: 'bill_id', field: '_id' }]
										}
									},
									{ original: '_id', shown: '_id', visible: false },
									/*
									{
										original: '_id', button: 'X', shown: 'Eliminar', visible: true, display: 'button',
										prefix: 'deletebill_', click_callback: this.deleteClick
									},
									*/
									{
										original: '_id', button: 'D', shown: 'Duplicar', visible: true, display: 'button',
										prefix: 'duplicatebill_', click_callback: this.duplicateClick, textCenter: 1
									},
									{
										original: '_id', button: 'A', shown: 'Abonar', visible: true, display: 'button',
										prefix: 'generateReturnPayBill_', click_callback: this.generateReturnPayBillClick, textCenter: 1
									}
								],
								pagination: {
									totalItems: this.props.billsPagination?.totalItems ? this.props.billsPagination.totalItems : 0,
									totalPages: this.props.billsPagination?.totalPages ? this.props.billsPagination.totalPages : 1,
									currentPage: this.props.billsPagination?.currentPage ? this.props.billsPagination.currentPage : 1,
									callback: this.clickPaginationCallback
								}
							}}
						/>
					</div>
				</div>
				<Modal />
				<Filters />
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		selectedFilters: state.selectedFilters,
		billsPagination: state.billsPagination
	};
}

const mapDispatchToProps = dispatch => {
	return {
		setModalContent(modalContent) {
			dispatch(setModalContent(modalContent));
		},
		setFiltersContent(filtersContent) {
			dispatch(setFiltersContent(filtersContent));
		},
		setSelectedFilters(selectedFilters) {
			dispatch(setSelectedFilters(selectedFilters));
		},
		setBillsPagination(pagination){
			dispatch(setBillsPagination(pagination));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Bills)
